var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBucketGeneralCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 20H3C2.448 20 2 20.448 2 21C2 21.552 2.448 22 3 22H21C21.552 22 22 21.552 22 21C22 20.448 21.552 20 21 20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1785 18.9957C9.9315 18.9957 10.6845 18.7087 11.2575 18.1357L18.8045 10.5887C19.1955 10.1977 19.1955 9.56569 18.8045 9.17469L10.5715 0.941688C10.1805 0.550687 9.5485 0.550687 9.1575 0.941688L1.6095 8.48769C0.4635 9.63369 0.4635 11.4997 1.6095 12.6457L7.0985 18.1347C7.6725 18.7087 8.4255 18.9957 9.1785 18.9957ZM9.8645 3.06169L16.6835 9.88069L16.5675 9.99669H2.9615C2.9855 9.96669 2.9965 9.92969 3.0245 9.90169L9.8645 3.06169Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.4189C17 17.8429 18.122 19.0019 19.5 19.0019C20.878 19.0019 22 17.8429 22 16.4189C22 15.2709 20.566 13.0059 20.126 12.3399C19.849 11.9179 19.151 11.9179 18.874 12.3399C18.434 13.0059 17 15.2709 17 16.4189Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucketGeneralCustomize);
export default __webpack_public_path__ + "static/media/bucket-general-customize.0f05f9077a21d718a51059b2e4421dec.svg";
export { ForwardRef as ReactComponent };